import React, { useState } from 'react';
import Layout from '../../components/Layout'
import { graphql } from 'gatsby'

export default function Test({ data }) {
    const total = data.allZot2021TestNalogeCsv.totalCount;
    const allData = data.allZot2021TestNalogeCsv.nodes;
    const [isToggleOn, setIsToggleOn] = useState(true);

    function icon(img){
        if (img=="VIDEO") {
            return <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z"></path></svg>
        } else if (img=="SLIKA") {
            return <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z" clip-rule="evenodd"></path></svg>
         } else {
             return <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clip-rule="evenodd"></path></svg>
         }
    }

    function test(){
        isToggleOn ? setIsToggleOn(false) : setIsToggleOn(true);

      }

    const listItems = allData.map((x) =>
        <section className="mt-5 text-container justify-center">
            <div className="flex py-4 md:py-6">
                <div className="pr-4 text-2xl">{x.st}.<br />
                <div className="pt-4">{icon(x.tip)}</div>
                </div>
                <div className="w-full">
                    <div className="flex justify-between mb-2 border-b border-primary border-opacity-50"><h2 className="text-2xl">{x.naslov}</h2><span className="border border-primary border-opacity-50 bg-primary border-b-0 bg-opacity-10 py-1 px-2">{x.st_tock} točk</span></div>
                    <div className={isToggleOn ? '' : 'hidden'}>
                        <p className="pb-4">
                            {x.opis}
                        </p>
                        <a className="px-3 py-2 text-center text-xl text-white bg-primary" href={x.link_obrazec} target="_blank">Oddaja</a>
                    </div>
                </div>

            </div>
        </section>
    );

    return (
        <Layout>
            <main className="container px-6 font-medium text-primary">
                <h1 className="text-5xl mt-16 mb-8 lg:text-6xl lg:my-16 xl:text-7xl xl:my-20 mb-5">PP+ naloge</h1>
                <section className=" lg:text-xl text-lg text-container">
                    <p className="pb-6">Pred vami se nahaja {total} nalog. Veliko sreče pri opravljanju nalog. :)</p>
                </section>

                {listItems}
            </main>
        </Layout>
    );
}

export const query = graphql`
query MyQuerySliva {
    allZot2021TestNalogeCsv {
      nodes {
        link_obrazec
        naslov
        opis
        tip
        st
        st_tock
      }
      totalCount
    }
  }  
`